<div id="document" *ngIf="report">

  <div [style]="styles.page">
    <app-front-page [report]="report" [download]="download"/>
  </div>

  <div [style]="styles.page">
    <app-introduction [report]="report" [download]="download"/>
  </div>

  <div [style]="styles.page">
    <app-styles [report]="report" [download]="download"/>
  </div>

<!-- Check for CoachingStyles Template IDs 1 or 5 -->
@if (this.report.templateId === AssessmentReportTemplate.CoachingStyles || this.report.templateId === AssessmentReportTemplate.CoachingStylesV2) {
  <div [style]="styles.page">
    <app-coachee-score-summary [report]="report" [download]="download"/>
  </div>

  <div [style]="styles.page">
    <app-coachee-primary-style [report]="report" [download]="download"/>
  </div>

  <div [style]="styles.page">
    <app-coachee-secondary-style [report]="report" [download]="download"/>
  </div>

  <div [style]="styles.page">
    <app-coachee-least-style [report]="report" [download]="download"/>
  </div>

  <div [style]="styles.page">
    <app-coachee-style-combinations [report]="report" [download]="download"/>
  </div>

  <div [style]="styles.page">
    <app-coachee-second-combinations [report]="report" [download]="download"/>
  </div>

  <div [style]="styles.page">
    <app-coachee-style-expression [report]="report" [download]="download"/>
  </div>

  <div [style]="styles.page">
    <app-improvements [report]="report" [download]="download"/>
  </div>
}

  @else {
    <div [style]="styles.page">
      <app-score-summary [report]="report" [download]="download"></app-score-summary>
    </div>

    <div [style]="styles.page">
      <app-primary-style [report]="report" [download]="download"></app-primary-style>
    </div>

    <div [style]="styles.page">
      <app-secondary-style [report]="report" [download]="download"></app-secondary-style>
    </div>

    <div [style]="styles.page">
      <app-least-style [report]="report" [download]="download"></app-least-style>
    </div>

    <!-- Facilitator: skip style combinations -->
    <div *ngIf="!isFacilitatorTemplate" [style]="styles.page">
      <app-style-combinations [report]="report" [download]="download"></app-style-combinations>
    </div>

    <div [style]="styles.page">
      <app-style-expression [report]="report" [download]="download"></app-style-expression>
    </div>

    <div [style]="styles.page">
      <app-improvements [report]="report" [download]="download"></app-improvements>
    </div>

  }

</div>